export function runScript(scriptEl: HTMLScriptElement) {
  return new Promise<void>((resolve, reject) => {
    const src = scriptEl.getAttribute('src')
    const newScript = document.createElement('script')
    if (scriptEl.getAttribute('type')) {
      newScript.setAttribute('type', scriptEl.getAttribute('type') as string)
    }

    if (src) {
      newScript.setAttribute('src', src)
      newScript.onload = () => resolve()
      newScript.onerror = reject
      document.body.appendChild(newScript)
    } else {
      const runScriptVar = '_ran' + Math.round(Math.random() * Number.MAX_SAFE_INTEGER)
      newScript.innerHTML = scriptEl.innerHTML + `\nwindow.${runScriptVar} = 1\n`
      document.body.appendChild(newScript)
      let waitForRunId = setInterval(() => {
        // @ts-ignore
        if (window[runScriptVar]) {
          // @ts-ignore
          delete window[runScriptVar]
          clearInterval(waitForRunId)
          resolve()
        }
      }, 5)
    }
  })
}
